import React from 'react';
import FadeInAnimation from './FadeInAnimation';

const SkillCard = ({ field }) => {
  // Destructure properties directly from educationData
  const { title, skill } = field;

  return (
    <FadeInAnimation>
      <div className="flex flex-row justify-between py-4 px-7">
        <div className="w-2/5">
          <h3 className="pt-3 text-xl font-medium md:text-2xl text-midground font-inter">{title}</h3>
        </div>

        <div className="flex flex-row flex-wrap justify-end w-3/5 gap-3 py-3 sm:gap-5 sm:py-0 sm:justify-between text-midground-accent">
          {skill.map((skill, index) => (
            <div key={index} className='flex flex-row justify-end text-right sm:text-start sm:items-center gap-x-3'>
              <img src={skill[1]} alt={skill[0]} className="hidden object-contain w-10 h-10 sm:block" />
              <h3 className='text-sm font-semibold sm:text-base'>{skill[0]}</h3>
            </div>
          ))}
        </div>
      </div>
    </FadeInAnimation>
  );
};

export default SkillCard;
